// features/schedule/queryKeys.ts
//
// Query key của lưới Lịch chụp, tách khỏi api.ts thành file lá (không import
// gì) vì feature khác cũng phải huỷ hiệu lực nó: sửa một đơn hàng là đổi luôn
// thứ lưới đang vẽ, mà mutation đó sống trong features/orders. Import thẳng
// api.ts sang đó sẽ mở đường cho một vòng phụ thuộc giữa hai feature.
//
// Gõ tay chuỗi "schedule" ở phía orders cũng chạy, nhưng khoá sẽ trôi lặng lẽ
// khi bên này đổi — người sửa không có gì nhắc.

export const scheduleKeys = {
  /** Gốc của mọi query lịch — huỷ hiệu lực nó là quét cả lưới. */
  all: ["schedule"] as const,
  /** Một khoảng ngày trên lưới. */
  range: (params: { from: string; to: string; branch?: string | undefined }) =>
    ["schedule", params] as const,
  postponed: ["schedule", "postponed"] as const,
  closures: ["schedule", "closures"] as const,
  closureRange: (params: { from: string; to: string; branch?: string | undefined }) =>
    ["schedule", "closures", params] as const,
  /** Thợ chụp có ca đã duyệt — không nhận branch: lưới xem nhiều cơ sở cùng lúc
   *  và BE đã gác phạm vi, nên một truy vấn cho cả khoảng ngày là đủ. */
  photoCoverage: (params: { from: string; to: string }) =>
    ["schedule", "photo-coverage", params] as const,
} as const;
